module.exports = __webpack_public_path__ + "sitepen.1Q6cDybn.svg";